module.exports = __webpack_public_path__ + "img/2.edf0127f.png";